import { z } from 'zod';

export const modalFormSchema = z.object({
  team_uuid: z.string().optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
